import React  from 'react';
import clsx from 'clsx';
import MarkdownBodySection1 from './MarkdownBodySection1';
import MarkdownBodySection2 from './MarkdownBodySection2';

/**
 *  This component renders the component that displays the main body 
 *  of markdown in aboutPage page. The main component is seperated in two 
 *  sections, MarkdownBodySection2 and MarkdownBodySection2. 
 */
const MarkdownBody = (props) => {
    
    const{
        refArray,
        elSubRefs,
        scrollTop
    } = props;
    
    return(
        <div  style={{marginLeft: '24%'}} className={clsx('col-xs-12', 'col-sm-12', 'col-md-9', 'col-lg-9')}>
            
            <MarkdownBodySection1 refArray={refArray} scrollTop={scrollTop}/> {/*   Markdown body section1  */}
            <MarkdownBodySection2 refArray={refArray} elSubRefs={elSubRefs}/> {/*   Markdown body section2 */}
            
        </div>       
    )
}

export default MarkdownBody;